module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flashHelp flexcenter"
  }, [_c('transition', [_c('div', {
    staticClass: "help flexcenter"
  }, [_c('dl', [_c('dd', [(_vm.platform.name == 'IE') ? _c('p', [_vm._v("音声機能を有効にするには[Shockwave Flash Object]を有効にする必要があります。")]) : _vm._e(), _vm._v(" "), (_vm.platform.name == 'Safari') ? _c('p', [_vm._v("音声機能を有効にするには[Adobe Flash Player]プラグインを有効にする必要があります。")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("以下の手順に従って、設定します。")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "help-anchor",
    attrs: {
      "href": "http://www.sourcenext.com/support/qa/?faq=RS-08935",
      "target": "_blank"
    }
  }, [_vm._v("http://www.sourcenext.com/support/qa/?faq=RS-08935")])]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "help-anchor",
    attrs: {
      "href": "http://www.sourcenext.com/support/qa/?faq=RS-08885",
      "target": "_blank"
    }
  }, [_vm._v("http://www.sourcenext.com/support/qa/?faq=RS-08885")])])])]), _vm._v(" "), _c('button', {
    staticClass: "return",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "close_text"
  }, [_vm._v("閉じる")])])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f5cff9ce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-f5cff9ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FlashHelp.vue
// module id = 642
// module chunks = 1